import { z } from 'zod';

// Mirror of the shared.link `type` enum in the Strapi schema (SharedLink in
// @personal-portfolio/cms-types). Drift is caught at compile time by
// ./link-types.assert.ts — typecheck fails when the CMS enum changes.
export const LINK_TYPES = [
  'other',
  'website',
  'github',
  'linkedin',
  'twitter',
  'instagram',
  'facebook',
  'youtube',
  'medium',
  'devto',
  'stackoverflow',
  'behance',
  'dribbble',
  'portfolio',
  'blog',
  'demo',
  'documentation',
  'app-store',
  'play-store',
  'figma',
  'notion',
  'discord',
  'telegram',
  'email',
  'phone',
  'resume',
  'certification',
  'company-profile',
] as const;

export type LinkType = (typeof LINK_TYPES)[number];

export const strapiEntitySchema = z.object({
  id: z.number(),
  documentId: z.string(),
  createdAt: z.string(),
  updatedAt: z.string(),
  publishedAt: z.string().nullish(),
  locale: z.string().nullish(),
});

export type StrapiEntity = z.infer<typeof strapiEntitySchema>;

// The Strapi REST envelope. Parsed in two steps by the api-client: envelope
// first, then the payload under `data` against the per-entity schema.
export const envelopeSchema = z.object({ data: z.unknown() });

export const mediaFileSchema = z.object({
  id: z.number(),
  name: z.string(),
  url: z.string(),
  alternativeText: z.string().nullish(),
});

export type StrapiMediaFile = z.infer<typeof mediaFileSchema>;

export const linkSchema = z.object({
  id: z.number(),
  label: z.string(),
  isVisible: z.boolean().nullish(),
  url: z.string(),
  type: z.enum(LINK_TYPES),
  showIcon: z.boolean().nullish(),
  isExternal: z.boolean().nullish(),
  description: z.string().nullish(),
});

export type StrapiLink = z.infer<typeof linkSchema>;

export const skillCategorySchema = z.object({
  id: z.number(),
  name: z.string(),
  color: z.string().nullish(),
  icon: z.string().nullish(),
});

export type StrapiSkillCategory = z.infer<typeof skillCategorySchema>;
